<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalSalesReturnDetail v-if="modalShowSalesReturnDetail" @closeModal="closeModal"
    :salesReturnDetail="selectedSalesReturnDetail" :parentItemId="$route.params?.id" />
  <ModalChooseReturnProduct v-if="modalShowChooseReturnProduct" @closeModal="closeModalProduct" :salesReturn="salesReturn" @submit="submitProduct" :productSalesReturn="productSalesReturn" />
  <ModalSalesOrder v-if="modalShowSalesOrder" @closeModal="closeModalOrder" @submit="submitOrder" :params="{ limit: 10, page: 1, status: 'paid' }" />
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30 flex items-center justify-center" :class="{ hidden: !isBlur }">
    <div class="bg-white dark:bg-dark-800 p-8 rounded-lg shadow-xl flex flex-col items-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mb-4"></div>
      <p class="text-gray-700 dark:text-gray-300">Memproses...</p>
    </div>
  </div>
  <ViewContainer>
    <section class="p-6">
      <BackButton class="mb-5" to_url="/sales-return" />
      <PageTitle title="Edit Retur Penjualan" />
      <div
        class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500 dark:text-dark-500">
        <div id="table-header" class="mb-5 mt-5 flex justify-between">
          <AddButton v-if="salesReturn.status != 'paid'" to_url="#" button_text="Pilih Item"
            button_class="text-base py-2 font-medium" @click="showModalProduct" />
          <AddButton v-if="salesReturn.status != 'paid'" to_url="#" button_text="Pilih Order"
            button_class="text-base py-2 font-medium" @click="showModalOrder" />
        </div>
        <InputTextCustom v-model="salesReturn.sales_order.code" label="Sales Order" id="pilih-so"
          placeholder="Sales Order" :valid="validation.sales_order_id.valid"
          :error-message="validation.sales_order_id.message" :disable_input="true" />
        <InputTextAreaCustom v-model="salesReturn.note" id="marketing-address" label="Catatan"
          placeholder="Catatan" input_class="w-full" :valid="validation.note.valid"
          :error-message="validation.note.message" />

        <div class="overflow-x-auto mt-5">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Action</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>Kode Item</TableHeadCell>
                    <TableHeadCell>Nama Item</TableHeadCell>
                    <TableHeadCell>Jumlah dipesan</TableHeadCell>
                    <TableHeadCell>Sudah diretur</TableHeadCell>
                    <TableHeadCell>Jumlah</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="salesReturnDetails?.length == 0">
                    <TableCell colspan="8" customClass="text-center italic text-gray-400 dark:text-dark-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(salesReturnDetail, index) in salesReturnDetails"
                    :key="salesReturnDetail.id" :index="index" isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>
                      <div class="justify-center items-center text-gray-500 dark:text-gray-400 flex" v-if="salesReturn.status != 'paid'">
                        <button v-if="salesReturnDetail.isEdit" :id="'edit-data-' + salesReturnDetail.id"
                          @click="submitSalesReturnDetail(salesReturnDetail)"
                          class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                          <ArrowDownTrayIcon class="h-4 w-4 group-hover:text-green-700" />
                        </button>
                        <button :id="'delete-data-' + salesReturnDetail.id"
                          @click="deleteSalesReturnDetail(salesReturnDetail)"
                          class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                          <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                        </button>
                      </div>
                    </TableCell>
                    <TableCell>
                      <span :class="{
                        'bg-red-500 dark:bg-red-500 text-light-50 dark:text-white': salesReturnDetail.isEdit,
                        'bg-green-500 dark:bg-green-500 text-white dark:text-white': !salesReturnDetail.isEdit
                      }" class="px-2 py-1 rounded-full text-sm font-medium">
                        {{ salesReturnDetail.isEdit ? 'Belum Disimpan' : 'Tersimpan' }}
                      </span>
                    </TableCell>
                    <TableCell>{{ salesReturnDetail.items?.code }}</TableCell>
                    <TableCell>{{ salesReturnDetail.items?.name }}</TableCell>
                    <TableCell>
                      {{ salesReturnDetail.qty_order }}
                    </TableCell>
                    <TableCell>
                      {{ salesReturnDetail.returnedQty }}
                    </TableCell>
                    <TableCell>
                      <div v-if="salesReturn.status != 'paid'" class="flex items-center rounded-lg p-1">
                        <button @click="reduceItem(salesReturnDetail)" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                          <MinusCircleIcon class="h-5 w-5" />
                        </button>
                        <InputTextCustom v-model="salesReturnDetail.qty" id="item-min-qty-per-unit" type="number" div_class="w-20" min="1" @input="inputQty(salesReturnDetail)"/>
                        <button @click="addItem(salesReturnDetail)" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                        <PlusCircleIcon class="h-5 w-5" />
                        </button>
                      </div>
                      <div v-else>
                        {{ salesReturnDetail.qty }}
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
            </div>
          </div>
        </div>

        <div class="flex justify-center gap-3" v-if="salesReturn.status != 'paid'">
          <Button type="submit" label="Simpan" :loading="loading" @click="submitSalesReturn" />
          <Button type="submit" label="Posting" :loading="loading" @click="submitCloseSalesReturn" />
        </div>
        <div class="flex justify-center" v-if="salesReturn.status == 'paid'">
          Sudah Diposting
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import InputTextAreaCustom from '@/components/form/InputTextAreaCustom.vue';
import { mapActions, mapGetters } from 'vuex';
import { Button, ConfirmDialog, Toast } from "primevue";
import AddButton from "@/components/buttons/AddButton.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import ModalSalesReturnDetail from '@/components/modals/ModalSalesReturnDetail.vue';
import { TrashIcon, ArrowDownTrayIcon, PlusCircleIcon, MinusCircleIcon } from "@heroicons/vue/24/solid";
import ModalChooseReturnProduct from '@/components/modals/ModalChooseReturnProduct.vue';
import ViewContainer from "@/components/ViewContainer.vue";
import InputTextCustom from '@/components/form/InputTextCustom.vue';
import ModalSalesOrder from '@/components/modals/ModalSalesOrder.vue';

export default {
  name: "AddEditCustomer",
  props: ['id'],
  components: {
    IndexView, InputTextAreaCustom, PageTitle, BackButton, Button, ConfirmDialog, Toast,
    AddButton, TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell,
    ModalSalesReturnDetail, TrashIcon, ModalChooseReturnProduct, ViewContainer, PlusCircleIcon, MinusCircleIcon, ArrowDownTrayIcon, InputTextCustom, ModalSalesOrder
  },
  data() {
    return {
      loading: false,
      selectedSalesOrder: null,
      salesReturn: {
        form_type: null,
        sales_order_id: null,
        note: "",
        sales_order: {
          code: null,
          id: null,
        },
      },
      salesReturnsPaid: [],
      salesReturnDetails: [],
      isEdit: false,
      validation: {
        form_type: {
          valid: true,
          message: ''
        },
        sales_order_id: {
          valid: true,
          message: ''
        },
        note: {
          valid: true,
          message: ''
        },
      },
      validationSalesReturnDetail: {
        item_id: {
          valid: true,
          message: ''
        },
        qty: {
          valid: true,
          message: ''
        },
      },
      modalShowSalesReturnDetail: false,
      isBlur: false,
      selectedSalesReturnDetail: null,
      modalShowChooseReturnProduct: false,
      modalShowSalesOrder: false,
    }
  },
  async created() {
    await this.fetchSalesOrders({ limit: 100, status: 'paid' });
    await this.fetchSalesReturnById();
    await this.fetchSalesReturnsPaid();
    await this.fetchSalesReturnDetails();
  },
  computed: {
    ...mapGetters("sales_orders", ["allSalesOrders"]),
    optionSalesOrder() {
      let options = [];
      options.push({ value: null, label: "Pilih SO" });
      options = options.concat(this.allSalesOrders.map((so) => ({
        value: so.id,
        label: so.code,
      })))
      return options;
    },
    productSalesReturn() {
      // const salesOrder = this.allSalesOrders.find((so) => so.id == this.salesReturn.sales_order_id);
      const salesOrder = this.selectedSalesOrder;
      if (!salesOrder) return [];

      // Group items by item_id and calculate quantities
      const itemQuantities = salesOrder.menus.reduce((acc, menu) => {
        const itemId = menu.item_id;
        let valid = false;

        try {
          JSON.parse(menu.product_mix);
          valid = true;
        } catch (error) {
          valid = false;
        }
        if (!acc[itemId]) {
          acc[itemId] = {
            code: menu?.items?.code,
            name: menu?.items?.name,
            id: itemId,
            qty: 0,
            max_qty: menu.qty,
            note: menu.note,
            has_product_mix: menu.has_product_mix,
            product_mix: menu.has_product_mix ? valid ? JSON.parse(menu.product_mix) : menu.product_mix : [],
          };
        }
    
        // Add to quantity if not canceled, subtract if canceled
        if (menu.status !== 'canceled') {
          acc[itemId].qty += menu.qty;
        } else {
          acc[itemId].qty -= menu.qty;
        }
        
        return acc;
      }, {});

      // Convert to array and filter out items with qty <= 0
      return Object.values(itemQuantities).filter(item => item.qty > 0);
    },
  },
  methods: {
    ...mapActions("sales_orders", ["fetchSalesOrders"]),
    ...mapActions('sales_returns', ['updateSalesReturn', 'closeSalesReturn']),
    ...mapActions('sales_return_details', ['deleteSalesReturnDetailById', 'createSalesReturnDetail', 'updateSalesReturnDetail']),
    async fetchSalesReturnById() {
      const response = await this.$store.dispatch('sales_returns/fetchSalesReturnById', this.$route.params.id);
      this.salesReturn = response.data;
      const responseSalesOrder = await this.$store.dispatch(
          "sales_orders/fetchSalesOrderById",
          response.data.sales_order_id
        );
      this.selectedSalesOrder = responseSalesOrder.data;
    },
    async fetchSalesReturnsPaid() {
      try {
        // Fetch paid sales returns for this sales order
        const response = await this.$store.dispatch("sales_returns/fetchSalesReturns", {
          sales_order_id: this.salesReturn.sales_order_id,
          status: 'paid',
        });
        this.salesReturnsPaid = response.data;
      } catch (error) {
        console.error('Error fetching sales returns:', error);
      }
    },
    async fetchSalesReturnDetails() {
      try {
        const response = await this.$store.dispatch('sales_return_details/fetchSalesReturnDetails', { 
          sales_return_id: this.$route.params.id, 
          limit: 1000 
        });
        
        if (response) {
          // Calculate returned quantities for each item across all paid returns
          const returnedQuantities = this.calculateReturnedQuantities();
          
          // Add returnedQty to each sales return detail
          this.salesReturnDetails = response.data.map(detail => ({
            ...detail,
            returnedQty: returnedQuantities[detail.item_id] || 0,
            qty_order: this.calculateMaxQTY(detail),
          }));
        } else {
          this.salesReturnDetails = [];
        }
      } catch (error) {
        console.error('Error fetching sales return details:', error);
        this.salesReturnDetails = [];
      }
    },
    // Helper method to calculate returned quantities for all items
    calculateReturnedQuantities() {
      if (!this.salesReturnsPaid || this.salesReturnsPaid.length === 0) {
        return {};
      }
      
      // Create an object to store total returned quantities by item_id
      const returnedQuantities = {};
      
      // Loop through all paid sales returns
      this.salesReturnsPaid.forEach(salesReturn => {
        // Skip the current sales return to avoid counting its own details
        if (salesReturn.id === this.$route.params.id) return;
        
        // Check if sales return has details
        if (salesReturn.details && salesReturn.details.length > 0) {
          // Sum quantities for each item
          salesReturn.details.forEach(detail => {
            const itemId = detail.item_id;
            const qty = parseFloat(detail.qty) || 0;
            
            if (!isNaN(qty)) {
              returnedQuantities[itemId] = (returnedQuantities[itemId] || 0) + qty;
            }
          });
        }
      });
      
      return returnedQuantities;
    },
    calculateMaxQTY(item) {
      const product = this.productSalesReturn;
      let maxQty = 0;

      product.forEach(p => {
        if (p.id == item.item_id) {
          maxQty = Number(p.qty || 0);
        } else {
          if (p.has_product_mix) {
            maxQty += p.product_mix.reduce((total, mix) => {
              return total + (item.item_id == mix.id ? Number(mix.quantity || 0)*Number(p.qty || 0) : 0);
            }, 0);
          }
        }
      });
      return maxQty;
    },
    addItem(item) {
      const existingItemIndex = this.salesReturnDetails.findIndex(detail => detail.item_id === item.item_id);
      const maxQty = this.calculateMaxQTY(item);

      if (existingItemIndex == -1) {
        this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Item tidak ditemukan', life: 3000 });
      } else if(Number(this.salesReturnDetails[existingItemIndex].qty)+1 > (maxQty - this.salesReturnDetails[existingItemIndex].returnedQty)) {
        this.$toast.add({ severity: 'error', summary: 'Rejected', detail: `Jumlah tidak bisa melebihi ${this.salesReturnDetails[existingItemIndex].returnedQty > 0 ? 'retur' : 'pembelian'} sebelumnya.`, life: 3000 });
      } else {
        this.salesReturnDetails[existingItemIndex].qty = Number(this.salesReturnDetails[existingItemIndex].qty) + 1;
        this.salesReturnDetails[existingItemIndex].isEdit = true;
      }
    },
    reduceItem(item) {
      const existingItemIndex = this.salesReturnDetails.findIndex(detail => detail.item_id === item.item_id);
      if (existingItemIndex != -1) {
        this.salesReturnDetails[existingItemIndex].qty = Number(this.salesReturnDetails[existingItemIndex].qty) > 1 ? Number(this.salesReturnDetails[existingItemIndex].qty) - 1 : 1;
        this.salesReturnDetails[existingItemIndex].isEdit = true;
      }
    },
    inputQty(item) {
      const maxQty = this.calculateMaxQTY(item);
      const returnedQty = this.salesReturnDetails.find((i) => i.item_id == item.item_id).returnedQty;
      if(Number(item.qty) > (maxQty - returnedQty)) {
        item.isEdit = true;
        item.qty = (maxQty - returnedQty);
        this.$toast.add({ severity: 'error', summary: 'Rejected', detail: `Jumlah tidak bisa melebihi ${returnedQty > 0 ? 'retur' : 'pembelian'} sebelumnya.`, life: 3000 });
      } else {
        item.isEdit = true;
        item.qty = Number(item.qty) <= 0 ? 1 : item.qty;
      }
    },
    submitSalesReturn() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin membuat draft barang masuk?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postSalesReturn();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan draft barang masuk', life: 3000 });
        }
      });
    },
    async postSalesReturn() {
      try {
        this.loading = true;
        const salesReturnData = {
          sales_order_id: this.salesReturn.sales_order_id,
          id: this.$route.params.id,
          note: this.salesReturn.note,
        };

        const isEdit = this.salesReturnDetails.filter(detail => detail.isEdit);

        if (isEdit.length > 0) {
          await this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Ada detail yang diubah. Harap simpan perubahan terlebih dahulu.', life: 3000 });
          return;
        }

        for await (const salesReturnDetail of this.salesReturnDetails) {
          await this.updateSalesReturnDetail(salesReturnDetail);
        }

        await this.updateSalesReturn(salesReturnData);
        await this.fetchSalesReturnById();

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Retur Penjualan telah dibuat', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save inbound items form:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },
    submitCloseSalesReturn() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin posting barang masuk?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postCloseSalesReturn();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan posting barang masuk', life: 3000 });
        }
      });
    },
    async postCloseSalesReturn() {
      try {
        this.loading = true;
        const salesReturnDataClose = {
          transaction_id: this.$route.params.id,
        };
        const salesReturnData = {
          sales_order_id: this.salesReturn.sales_order_id,
          id: this.$route.params.id,
          note: this.salesReturn.note,
        };

        const isEdit = this.salesReturnDetails.filter(detail => detail.isEdit);

        if (isEdit.length > 0) {
          await this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Ada detail yang diubah. Harap simpan perubahan terlebih dahulu.', life: 3000 });
          return;
        }

        await this.updateSalesReturn(salesReturnData);
        await this.closeSalesReturn(salesReturnDataClose);
        await this.fetchSalesReturnById();

        // if (this.isEdit && this.salesReturn) {
        //   salesReturnData.id = this.salesReturn.id;
        //   await this.updateSalesReturn(salesReturnData);
        // }
        // else {
        //   await this.createSalesReturn(salesReturnData);
        // }

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Retur Penjualan telah dibuat', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save inbound items form:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },

    editSalesReturnDetail(salesReturnDetail) {
      this.selectedSalesReturnDetail = salesReturnDetail;
      this.modalShowSalesReturnDetail = true;
      this.isBlur = true;
    },
    async deleteSalesReturnDetail(table) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menghapus detail?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: async () => {
          try {
            this.isBlur = true;
            await this.deleteSalesReturnDetailById(table.id);
            this.fetchSalesReturnDetails();
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil menghapus detail', life: 3000 });
          }
          catch (error) {
            console.error('Gagal menghapus detail', error);
            this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal menghapus detail', life: 3000 });
          }finally {
            this.isBlur = false;
          }
        },
        reject: () => {
          this.isBlur = false;
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal menghapus detail', life: 3000 });
        }
      });
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    },
    showModal() {
      this.modalShowSalesReturnDetail = true;
      this.isBlur = true;
      this.selectedSalesReturnDetail = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowSalesReturnDetail = false;
        this.isBlur = false;
        this.fetchSalesReturnDetails();
      }, 200);
    },
    showModalProduct() {
      this.modalShowChooseReturnProduct = true;
      this.isBlur = true;
    },
    closeModalProduct() {
      setTimeout(() => {
        this.modalShowChooseReturnProduct = false;
        this.isBlur = false;
      }, 200);
    },
    async submitProduct(items) {
      try {
        for await (const item of items) {
          const salesReturnDetailData = {
            sales_return_id: this.$route.params.id,
            item_id: item.id,
          };

          const existingItem = this.salesReturnDetails.find(detail => detail.item_id === item.id);

          if (existingItem) {
            salesReturnDetailData.id = existingItem.id;
            await this.updateSalesReturnDetail(salesReturnDetailData);
          }
          else {
            salesReturnDetailData.qty = 0;
            await this.createSalesReturnDetail(salesReturnDetailData);
          }
        }

        this.closeModalProduct();
        this.fetchSalesReturnDetails();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Item berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save item:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    submitSalesReturnDetail(item) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan item?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postSalesReturnDetail(item);
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan item', life: 3000 });
        }
      });
    },
    async postSalesReturnDetail(item) {
      try {
        this.isBlur = true;
        const salesReturnDetailData = {
          sales_return_id: this.parentItemId,
          item_id: item.item_id,
          qty: item.qty,
        };

        if (item.isEdit && item.id) {
          salesReturnDetailData.id = item.id;
          await this.updateSalesReturnDetail(salesReturnDetailData);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Item berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save item:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationSalesReturnDetailErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }finally {
        this.isBlur = false;
      }
    },
    validationSalesReturnDetailErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validationSalesReturnDetail[this.field[index]].valid = true;
        this.validationSalesReturnDetail[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validationSalesReturnDetail[error.field]) {
          this.validationSalesReturnDetail[error.field].valid = false;
          this.validationSalesReturnDetail[error.field].message = error.message;
        }
      });
    },  
    showModalOrder() {
      this.modalShowSalesOrder = true;
      this.isBlur = true;
    },
    closeModalOrder() {
      this.isBlur = false;
      this.modalShowSalesOrder = false;
    },
    async submitOrder(order) {
      try {
        const salesReturnData = {
          sales_order_id: order.id,
          id: this.$route.params.id,
          note: this.salesReturn.note,
        };
        await this.updateSalesReturn(salesReturnData);
        if (this.salesReturn.sales_order_id != order.id) {
          for await (const salesReturnDetail of this.salesReturnDetails) {
            console.log("sales return detail", salesReturnDetail);
            await this.deleteSalesReturnDetailById(salesReturnDetail.id);
          }
        }
        await this.fetchSalesReturnById();
        await this.fetchSalesReturnDetails();
        this.isBlur = false;
        this.modalShowSalesOrder = false;
      }
      catch (error) {
        console.error('Gagal mengubah order', error);
        this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal mengubah order', life: 3000 });
      }
    },
  },
}
</script>